import React from 'react';

var MobileGameWr = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: 'pgc-m-game-wrapper' }, children));
};

export { MobileGameWr };
